// extracted by mini-css-extract-plugin
export var inline = "_ur-0";